import React, { useState } from 'react';
import { Download, Mail, X, Loader2 } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const WorkshopExportModal = ({ isOpen, onClose, onExport, onOpenAuth, projectName, bpm }) => {
  const [step, setStep] = useState('email'); // email | exporting | done
  const [email, setEmail] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [error, setError] = useState(null);

  if (!isOpen) return null;

  const handleExport = async () => {
    setError(null);
    setStep('exporting');
    try {
      // Capture email to D1 if provided (non-blocking)
      if (email && email.includes('@')) {
        fetch(`${BACKEND_URL}/api/v1/platform/export-capture`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email, display_name: displayName || null, beat_id: null }),
        }).catch(() => {});
      }
      // Build filename: [DisplayName]_[BPM]bpm_[Date].mp3
      const name = (displayName || 'Creator').replace(/\s+/g, '_');
      const date = new Date().toISOString().slice(0, 10).replace(/-/g, '');
      const filename = `${name}_${bpm}bpm_${date}.mp3`;
      // Trigger actual export (always downloads, no email required)
      await onExport?.(filename);
      setStep('done');
    } catch (e) {
      setError('Export failed. Try again.');
      setStep('email');
    }
  };

  if (step === 'done') {
    return (
      <div data-testid="workshop-export-modal" className="fixed inset-0 z-50 flex items-center justify-center" style={{ background: 'rgba(0,0,0,0.7)' }}>
        <div className="flex flex-col items-center" style={{ width: 420, background: '#0A0A0A', borderRadius: 16, border: '1px solid #2A2A2A', padding: '40px 32px' }}>
          <img src="/pizzul/satisfied.png" alt="Pizzul is satisfied with your beat" style={{ width: 96, height: 96, marginBottom: 8, objectFit: 'contain' }} />
          <span style={{ fontSize: 18, fontWeight: 700, color: '#fff', marginBottom: 8 }}>Your beat is ready!</span>
          <p style={{ fontSize: 13, color: '#aaa', textAlign: 'center', lineHeight: 1.6, marginBottom: 24 }}>
            Your beat is saved for 7 days. Create a free account to keep it forever and share it with family.
          </p>
          <button
            data-testid="workshop-create-account"
            onClick={() => { onClose?.(); onOpenAuth?.(); }}
            style={{ height: 42, borderRadius: 22, padding: '0 28px', fontSize: 14, fontWeight: 600, background: '#00D4AA', color: '#0A0A0A', border: 'none', cursor: 'pointer', marginBottom: 12 }}
          >Create Account</button>
          <button onClick={onClose} style={{ fontSize: 12, color: '#666', background: 'none', border: 'none', cursor: 'pointer' }}>Not Now</button>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="workshop-export-modal" className="fixed inset-0 z-50 flex items-center justify-center" style={{ background: 'rgba(0,0,0,0.7)' }}>
      <div style={{ width: 420, background: '#0A0A0A', borderRadius: 16, border: '1px solid #2A2A2A', overflow: 'hidden' }}>
        <div className="flex items-center justify-between px-5 py-4 border-b" style={{ borderColor: '#2A2A2A' }}>
          <span style={{ fontSize: 15, fontWeight: 700, color: '#fff' }}>Export Your Beat</span>
          <button onClick={onClose} style={{ width: 28, height: 28, borderRadius: 8, background: '#1A1A1A', color: '#666', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><X size={14} /></button>
        </div>
        <div className="px-5 py-5 flex flex-col gap-3">
          <p style={{ fontSize: 14, fontWeight: 600, color: '#fff' }}>Download your beat as MP3</p>
          <input data-testid="workshop-export-name" placeholder="What should we call you on your track? (optional)" value={displayName} onChange={(e) => setDisplayName(e.target.value)} className="outline-none" style={{ height: 40, borderRadius: 8, padding: '0 14px', background: '#1A1A1A', color: '#fff', border: '1px solid #2A2A2A', fontSize: 13 }} />
          {error && <span style={{ fontSize: 12, color: '#FF0022' }}>{error}</span>}
          <button data-testid="workshop-export-submit" onClick={handleExport} disabled={step === 'exporting'} style={{ height: 42, borderRadius: 22, fontSize: 14, fontWeight: 600, background: step === 'exporting' ? '#1A1A1A' : '#00D4AA', color: step === 'exporting' ? '#666' : '#0A0A0A', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
            {step === 'exporting' ? <><Loader2 size={15} className="animate-spin" /> Rendering...</> : <><Download size={15} /> Download MP3 Now</>}
          </button>
          <div style={{ borderTop: '1px solid #2A2A2A', paddingTop: 12, marginTop: 4 }}>
            <p style={{ fontSize: 12, color: '#666', marginBottom: 8 }}>Want it emailed too? Enter your email:</p>
            <input data-testid="workshop-export-email" type="email" placeholder="Email (optional)" value={email} onChange={(e) => setEmail(e.target.value)} className="outline-none" style={{ height: 36, borderRadius: 8, padding: '0 14px', background: '#1A1A1A', color: '#fff', border: '1px solid #2A2A2A', fontSize: 12, width: '100%' }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkshopExportModal;
